import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { useMutation } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'
import { CompanySelect, FF2, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'
import { SarEditPayload } from '~bank-bsa-reporting/types/sar'

import { payloadToFormMapperSubjectInfo } from '../../../../../helpers/payloadMapper'

export const CompanyId = () => {
  const { control, setValue } = useFormContext<SarEdit>()

  const id = useWatch({ control, name: 'id' })
  const companyId = useWatch({ control, name: 'generalInfo.companyId' })
  const companyName = useWatch({ control, name: 'generalInfo.companyName' })

  const { mutate } = useMutation<{ subjectsInfo: SarEditPayload['subjectsInfo'] }, Error, { companyId: number }>({
    mutationFn: ({ companyId }) => Request.post(Request.urls.bank.sarCompany, { companyId }),
    onSuccess: (value) => {
      setValue('subjectsInfo', payloadToFormMapperSubjectInfo(value.subjectsInfo))
    }
  })

  const selectOptions = companyName
    ? [
        {
          label: companyName,
          value: companyId
        }
      ]
    : undefined

  return (
    <Controller
      name="generalInfo.companyId"
      control={control}
      rules={{ validate: Validators.required.field }}
      render={({ field }) => (
        <FF2
          required
          field={field}
          label="Company"
          input={(props) => (
            <CompanySelect
              {...props}
              preloadedOptions={selectOptions}
              hideMyCompaniesFilter={true}
              data-qa="General. Company"
              options-data-qa="General. Company option"
              disabled={id > 0 && companyId > 0}
              onChange={(value: number) => {
                if (id === 0) {
                  mutate({ companyId: value })
                }
                field.onChange(value)
              }}
            />
          )}
        />
      )}
    />
  )
}
